<div
    class="selection"
    [hidden]="
        wizardService.selection.length < 1 && !eventService.isAddingContact && data.mode !== 'class-change-attendees'
    "
>
    <div class="selection-header">
        <ng-container *ngIf="isRemovingOnly; else showDefault">
            <span class="strong">{{ wizardService.selection.length }}</span> invitees:
            <span class="italic">Remove attendees from your group class and then click Next.</span>
        </ng-container>
        <ng-template #showDefault>
            <div
                [hidden]="(wizardService.selection$ | async)?.length < 1"
                class="selection-header__content"
            >
                <div class="content__instructions">
                    <span class="strong">{{ wizardService.selection.length }}</span> invitees:
                    <span class="italic">Calendar invites will be sent to the email address appearing below.</span>
                </div>
                <div
                    [class.hidden]="(wizardService.selection$ | async)?.length < 2 || hideVIP"
                    class="content__vip"
                >
                    <div class="vip__tooltip">
                        <i class="icon yellow star"></i> VIP Invitee
                        <wizard-tooltip>
                            Mark an invitee as "VIP" in a group meeting to give them more influence over meeting times
                            and ensure the meeting doesn't happen without them. For example - a pivotal client or
                            internal stakeholder who must be in attendance. VIPs must be available to meet for the
                            meeting to go forward.
                            <a
                                href="https://faq.calendarhero.com/hc/en-us/articles/4430374418331-Can-I-mark-an-invitee-as-VIP-or-Required-"
                                target="_blank"
                            >
                                Please read the full documentation here.</a
                            >
                        </wizard-tooltip>
                    </div>

                    <div class="ui toggle checkbox toggle-vip">
                        <input
                            type="checkbox"
                            name="mark-all-vip"
                            [(ngModel)]="toggleAllVIP"
                            (ngModelChange)="handleToggleAllVIP(toggleAllVIP)"
                            id="mark-all-vip"
                        />
                        <label for="mark-all-vip">Mark all as VIP</label>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
    <div
        class="card-container"
        [ngClass]="{
            hidden: wizardService.selection.length === 0 && !eventService.isAddingContact
        }"
        data-testid="invitees"
    >
        <ng-container *ngFor="let selectedItem of selection$ | async; trackBy: trackSelection">
            <zoom-contact-card
                class="contact-card"
                [contact]="selectedItem"
                [numberOfSelections]="numberOfSelections"
                [isVIP]="selectedItem | checkIsVIP: vipContacts"
                [hideVIP]="hideVIP"
                (onRemove)="handleRemove($event)"
                (onMarkAsRequired)="handleMarkAsRequired($event)"
                (onUpdateContactEmailDefault)="handleUpdateContactEmailDefault($event)"
                (onMarkAsVIP)="handleMarkAsVIP($event)"
            ></zoom-contact-card>
        </ng-container>
        <ng-container *ngIf="eventService.isAddingContact">
            <zoom-new-contact-card
                (onAdd)="handleAddContact($event)"
                (onClose)="handleCloseAddContact()"
                [isLoading]="isAddingContact"
            ></zoom-new-contact-card>
        </ng-container>
    </div>
    <div
        *ngIf="errorContacts.length"
        class="error"
    >
        A problem was encountered while finding or adding these contacts:
        <ul>
            <li *ngFor="let contact of errorContacts">{{ contact.email }}<br /></li>
        </ul>
        Please add them using the dropdown above.
    </div>
</div>
